import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Resets window scroll position to the top whenever the route pathname changes.
 * Must be rendered inside a Router context.
 */
const ScrollToTop: React.FC = () => {
  const { pathname, state } = useLocation()
  const previousPathnameRef = useRef('')

  useEffect(() => {
    const previousPathname = previousPathnameRef.current
    const isInitialRender = previousPathname === ''
    const hasPathnameChanged = !isInitialRender && previousPathname !== pathname
    const isVisualExplorerTabNavigation =
      previousPathname !== '' && previousPathname !== pathname && previousPathname.startsWith('/visual-explorer/') && pathname.startsWith('/visual-explorer/')
    const skipScrollToTopFromState = (state as { skipScrollToTop?: boolean } | null)?.skipScrollToTop === true
    previousPathnameRef.current = pathname

    // Scroll changes are only expected for initial render or actual pathname changes.
    if (!isInitialRender && !hasPathnameChanged) {
      return
    }

    if (isVisualExplorerTabNavigation) {
      return
    }

    if (skipScrollToTopFromState) {
      return
    }
    window.scrollTo(0, 0)
  }, [pathname, state])

  return null
}

export default ScrollToTop
